import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  useAddDeliveryInformationMutation,
  useGetDeliveryInformationQuery,
  useUpdateDeliveryInformationMutation,
} from "../../../store/services/DeliveryInformation";
import toast from "react-hot-toast";

const MinSpendModal = ({ show, onHide }) => {
  const [addDeliveryInformation, { isLoading: isAdding }] =
    useAddDeliveryInformationMutation();
  const [updateDeliveryInformation, { isLoading: isUpdating }] =
    useUpdateDeliveryInformationMutation();
  const { data: deliveryData, isLoading: isDeliveryLoading } =
    useGetDeliveryInformationQuery();
  const deliveryInfo = deliveryData?.data?.[0] || null;
  useEffect(() => {
    deliveryFormik.setFieldValue("minimumSpend", deliveryInfo?.minimumSpend);
    deliveryFormik.setFieldValue(
      "deliveryCharges",
      deliveryInfo?.deliveryCharges
    );
  }, [isDeliveryLoading, show]);
  const deliveryFormik = useFormik({
    initialValues: {
      minimumSpend: deliveryInfo?.minimumSpend || "",
      deliveryCharges: deliveryInfo?.deliveryCharges || "",
    },
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (!deliveryInfo) {
          await addDeliveryInformation(values).unwrap();
          toast.success("Delivery Information Added!");
        } else {
          await updateDeliveryInformation({
            updatedData: values,
          }).unwrap();
          toast.success(" Minimum Spend Order value Updated!");
        }
      } catch (err) {
        toast.error("Failed to save Minimum Spend Order value");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const isSubmitting = isAdding || isUpdating || isDeliveryLoading;
  const [enableTextField, setEnablTextField] = useState(false);
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="m-0 fw-bold themeBlue">
          Minimum Spend Management
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={deliveryFormik.handleSubmit}>
          <div className="mb-3">
            <label htmlFor="minThreshold" className="form-label">
              Minimum Spend Order value
            </label>
            <input
              id="minThreshold"
              name="minimumSpend"
              type="number"
              onFocus={() => setEnablTextField(true)}
              placeholder="Enter Minimum Spend Order value"
              className="form-control"
              value={deliveryFormik.values.minimumSpend}
              onChange={deliveryFormik.handleChange}
              onBlur={deliveryFormik.handleBlur}
              required
              disabled={isSubmitting}
            />
            {deliveryFormik.touched.minThreshold &&
              deliveryFormik.errors.minThreshold && (
                <div className="text-danger small">
                  {deliveryFormik.errors.minThreshold}
                </div>
              )}
          </div>
          
          <div className="mb-3">
            <label htmlFor="deliveryCharges" className="form-label">
              Delivery Charges
            </label>
            <input
              id="deliveryCharges"
              name="deliveryCharges"
              type="text"
              placeholder="Enter Delivery Charges"
              className="form-control"
              value={deliveryFormik.values.deliveryCharges}
              onChange={deliveryFormik.handleChange}
              onBlur={deliveryFormik.handleBlur}
              required
              disabled={isSubmitting}
            />
            {deliveryFormik.touched.deliveryCharges &&
              deliveryFormik.errors.deliveryCharges && (
                <div className="text-danger small">
                  {deliveryFormik.errors.deliveryCharges}
                </div>
              )}
          </div>
          <div className="d-flex justify-content-end gap-2">
            <Button
              className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
              variant="secondary"
              onClick={onHide}
              type="button"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              className="d-flex align-items-center justify-content-center commonBtn "
              variant="primary"
              type="submit"
              disabled={isSubmitting || (deliveryInfo && !deliveryFormik.dirty)}
            >
              {deliveryInfo ? "Update" : "Add"}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default MinSpendModal;
